import React from 'react'
import PropTypes from 'prop-types'
import Heading from "../../shared/typography/heading";
import Description from "../../shared/typography/description";
import CloseButton from "../../shared/closebutton";

let Maintenance = ({heading,description}) =>{
  return (
      <div className={'of-maintenance of-page'}>
        <div className={'of-maintenance__wrapper clearfix'}>
          <Heading className={`of-maintenance__heading`}>{heading}</Heading>
          <Description className={`of-maintenance__description`}>{description}</Description>
          <CloseButton className={`of-maintenance__close-button`}/>
        </div>
      </div>
  )
}


Maintenance.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string
}

export default Maintenance